<template>
  <el-container class="card">
    <img
      id="logo"
      src="../assets/labelswap_logo.png"
      alt="Labelswap logo"
    >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      size="small"
    >
      <label>Username</label>
      <el-form-item
        size="small"
        prop="name"
      >
        <el-input
          ref="username"
          v-model.trim="form.name"
          class="form-input"
          autofocus
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
        />
      </el-form-item>
      <label>Password</label>
      <el-form-item
        prop="password"
        size="small"
      >
        <el-input
          v-model.trim="form.password"
          class="form-input"
          type="password"
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          class="form-button"
          type="primary"
          size="small"
          @click="submitForm('form')"
        >
          Submit
        </el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      labelPosition: 'top',
      form: {
        name: '',
        password: '',
      },
      rules: {
        name: [
          // validation rules here if needed
        ],
        password: [
          // validation rules here if needed
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const username = this.form.name;
          const { password } = this.form;
          // Uses vuex action login to handle auth
          this.$store.dispatch('auth/login', { username, password }, { root: true })
            .then(() => {
              this.$router.push('/action');
            })
            .catch(({ response: { status } }) => {
              if (status === 400) {
                this.$message.error('Username or Password is incorrect.');
              }
            });
        } else {
          return false;
        }
        return false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  $form-element-size: 22vw;
  $form-element-min-width: 230px;

  #logo {
    width: $form-element-size;
    height: auto;
    min-width: $form-element-min-width;
    margin: 0.6vw;
  }

  .form-input {
    box-sizing: border-box;
    width: $form-element-size + 1.5vw;
    min-width: $form-element-min-width;
    border: 0.11em solid black;
  }

  .form-button {
    font-size: 1.23em;
    width: $form-element-size + 1.5vw;
    min-width: $form-element-min-width;
    margin-top: 1.3vw;
  }
</style>